<template>
  <v-app>
    <!-- Spinner -->
    <div class="text-center spinner" v-if="isLoading">
      <v-progress-circular size="50" indeterminate color="primary" />
    </div>
    <!-- Contenido -->
    <v-main v-else>
      <!-- Contenedor principal -->
      <v-container class="pa-0 fill-height" fluid>
        <!-- Primera fila -->
        <v-row class="fill-height" no-gutters>
          <!-- Barra de navegación -->
          <v-col
            v-if="$vuetify.breakpoint.smAndDown || !isAuthenticated"
            cols="12"
          >
            <NavigationBar />
          </v-col>
          <!-- Columna para el menú -->
          <v-col v-else>
            <!-- Menú lateral -->
            <SideMenu class="side-menu-height" />
          </v-col>
          <!-- Columna para el contenido de la página -->
          <v-col class="fill-height" cols="12" :md="isAuthenticated ? 11 : 12">
            <!-- Contenido de la ruta -->
            <router-view />
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
// Importar componentes
import NavigationBar from "@/components/NavigationBar";
const SideMenu = () => import("@/components/SideMenu");

// Importar acciones
import { USER_PROFILE_REQUEST } from "@/store/actions/user";

// Importar servicios
import AuthServices from "@/services/AuthServices";

// Importar dependencias
import { mapGetters } from "vuex";

export default {
  name: "App",
  components: {
    NavigationBar,
    SideMenu
  },
  computed: {
    ...mapGetters(["isAuthenticated", "getProfile"])
  },
  data() {
    return {
      isLoading: true,
      showSideMenu: true,
      snackbar: false,
      timeout: 20000
    };
  },
  created: async function() {
    // Asegurarse de que el usuario está registrado
    if (this.$store.getters.isAuthenticated) {
      try {
        // Obtener perfil del usuario
        await this.$store.dispatch(USER_PROFILE_REQUEST);
        this.isLoading = false;

        // Mostrar snackbar si el correo del usuario no está verificado
        if (
          !this.getProfile.is_email_verified &&
          this.$route.name !== "verify-token"
        ) {
          this.snackbar = true;
        }

        // Autenticar usuario con mixpanel
        this.$mixpanel.identify(this.getProfile.business_id);
      } catch (err) {
        this.isLoading = false;
        // Mostrar el error
        alert(err.message);
      }
    } else {
      this.isLoading = false;
    }
  },
  methods: {
    sendEmailVerification: async function() {
      try {
        const result = await AuthServices.sendEmailVerification();

        if (result.sent) {
          // Ocultar snackbar
          this.snackbar = false;
        }
      } catch (err) {
        // Mostrar error
        alert(err.message);
      }
    }
  }
};
</script>

<style>
@import "./assets/globals.css";

.spinner {
  height: 100% !important;
  display: flex;
  justify-content: center;
  align-items: center;
}

.side-menu-height {
  min-height: calc(100vh - 65px);
  height: 100%;
}
</style>
